<template>
  <div class="c-topbar">
    <div class="c-topbar__logo">
      <the-image :srcUrl="'/icon/logo.svg'" :alt="'DBOK logo'">
      </the-image>
    </div>
    <div class="c-topbar__title">
      Flerspråklig veiledningsfilm
    </div>
  </div>
</template>

<script>
import TheImage from '@/components/TheImage.vue';

export default {
  name: 'TheTopbar',

  components: {
    TheImage,
  },
};
</script>


<style>
.c-topbar {
  padding: 20px 25px;
  background: #000;
  color: #ddd;
}

.c-topbar__logo {
  max-width: 140px;
  width: 100%;
  display: inline-block;
}

.c-topbar__title {
  display: inline-block;
  font-size: 20px;
  margin-left: 30px;
}
</style>
